import ItemMenuSquares from 'global/wrappers/ItemMenuSquares'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import WrapperVertCols from 'global/wrappers/WrapperVertCols'
import React, { createContext, useState } from 'react'
import { allDataModes_event } from './AppDashboard'
import FullPageWrapper from 'global/wrappers/FullPageWrapper'
import AppDashboardContent from './AppDashboardContent'

export const AppDashboardContext = createContext();

export const AppDashboardOptions = ({ handleCancel }) => {

  const [selectedListType, setSelectedListType] = useState(allDataModes_event.appCheck)

  const hc_appUsers = (mt) => {
    setSelectedListType(mt?.key)
  }

  const hc_selectedIndex = (s) => { }

  const squareText = (key) => {
    switch (key) {
      default:
        return _.startCase(key)
    }
  }

  const squareIcon = (key) => {
    switch (key) {
      case allDataModes_event.allClientAppUsers:
        return { icon: 'settings', iconColor: 'grey' }
      default:
        return { icon: 'settings', iconColor: 'grey' }
    }
  }

  const ims_opts = () => {
    const mis = _.mapValues(_.keyBy(allDataModes_event), (v) => ({
      key: v,
      caption: squareText(v),
      ...squareIcon(v),
      selected: v === selectedListType,
    }));
    console.log('mis', mis)
    return <ItemMenuSquares caption={'Options'} menuItems={mis} onClick={hc_appUsers} icon={'options'} />
  }

  const wrapper_opts = () => <Wrapper
    header={'App Users'}
    content={ims_opts()}
    wrapperType={wrapperTypes.padded}
  />

  const wrapper_content = () => <Wrapper
    header={_.startCase(selectedListType)}
    content={<AppDashboardContent currentDataMode={selectedListType} handleDataMode={setSelectedListType} />}
    wrapperType={wrapperTypes.padded}
  />

  const wvc = () => <WrapperVertCols mvc={'4'} split={false} handleSelectedIndex={hc_selectedIndex}>
    {wrapper_opts()}
    {wrapper_content()}
  </WrapperVertCols>

  const fpw = () => <FullPageWrapper
    content={wvc()}
    handleCancel={handleCancel}
    css={{ container: 'app-dark-mode' }}
    topperCaption={'App Dashboard Options!!!'}
  />

  return <AppDashboardContext.Provider value={{ appDashboard_state: { isSplit: true } }}>
    {fpw()}
  </AppDashboardContext.Provider>

}
